import { type Credentials } from "@alice-and-bot/core";
import { Widget } from "@alice-and-bot/core/components";
import { signal } from "@preact/signals";
import { toast } from "react-hot-toast";
import { resetText } from "../../constants.ts";
import { Button } from "./components.tsx";
import { useActiveUser } from "./loginHooks.ts";

export const showWidget = signal(false);

const botToTalkTo = signal<null | string>(null);

const userCredentials = signal<null | Credentials>(null);

export const ChatWidget = () => {
  if (!showWidget.value) return null;
  if (!userCredentials.value || !botToTalkTo.value) return null;
  return (
    <Widget
      participants={[botToTalkTo.value]}
      onNameChosen={() => {}}
      credentials={userCredentials.value}
      colorScheme={{
        light: {
          primary: "#2563eb",
          startButton: "#2563eb",
        },
        dark: {
          primary: "#3b82f6",
          startButton: "#3b82f6",
        },
      }}
      startOpen
    />
  );
};

export const webChatDemo = (user: Credentials, bot: Credentials) => {
  userCredentials.value = user;
  botToTalkTo.value = bot.publicSignKey;
  showWidget.value = true;
};

export const TalkToBotSection = ({ bot }: { bot: Credentials }) => {
  const user = useActiveUser();
  if (!user) return null;
  return (
    <Button
      onClick={() => {
        if (showWidget.value) {
          showWidget.value = false;
          return;
        }
        webChatDemo(user.aliceAndBotCredentials, bot);
        toast(`To reset the conversation, send "${resetText}"`, {
          icon: "💡",
          duration: 5000,
        });
      }}
    >
      {showWidget.value ? "Close widget" : "Talk to bot here"}
    </Button>
  );
};
